import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
    createChipcardSession (patientId, appointmentId) {
        return client().get('Chipcard/CreateChipcardSession', { params: {idCita: appointmentId, idPatient: patientId} })
    }
}


// WEBPACK FOOTER //
// ./src/repositories/ChipcardRepository.js